export default __webpack_public_path__ + "731673c749e57bf6f5442696ce248f54.svg";